const domReady = {
  methods: {
    $domReady(fn) {
      // if (process.env.NODE_ENV === 'production') {
      //   return this.$nextTick(fn)
      // }

      setTimeout(() => {
        this.$nextTick(fn);
      }, 3000)
    }
  }
}

export default domReady
